// extracted by mini-css-extract-plugin
export var carrierIcon = "_wu-0";
export var carrierLogo = "_wu-1";
export var detailsSection = "_wu-2";